const routes = [
  {
    path: 'piccolor',
    name: 'piccolor',
    component: () => import(/* webpackChunkName: "piccolor" */ '@/modules/piccolor/index.vue')
  },
];

export default routes;